/** @flow */

import { cloneObject } from "@utils/object";
import {
  GetEffectiveUserPermissions,
  GetEffectiveUserPermissionsSuccess,
  GetEffectiveUserPermissionsError,
  GetEffectiveUserPermissionsSchema,
  GetEffectiveUserPermissionsSchemaSuccess,
  GetEffectiveUserPermissionsSchemaError,
  UpdateEffectiveUserPermissions,
  UpdateEffectiveUserPermissionsSuccess,
  UpdateEffectiveUserPermissionsError,
  ToggleEmployeeUsersModal,
} from "@modules/service/constants/actions";
import * as userPermissionsReducers from "./reducers";
import initialState from "./state";
import type { UserPermissionsState } from "./types";

export default (
  state: UserPermissionsState = initialState,
  action: Object,
): UserPermissionsState => {
  const act = {
    [GetEffectiveUserPermissions]: userPermissionsReducers.onGetEffectiveUserPermissions,
    [GetEffectiveUserPermissionsSuccess]:
      userPermissionsReducers.onGetEffectiveUserPermissionsSuccess,
    [GetEffectiveUserPermissionsError]: userPermissionsReducers.onGetEffectiveUserPermissionsError,
    [GetEffectiveUserPermissionsSchema]:
      userPermissionsReducers.onGetEffectiveUserPermissionsSchema,
    [GetEffectiveUserPermissionsSchemaSuccess]:
      userPermissionsReducers.onGetEffectiveUserPermissionsSchemaSuccess,
    [GetEffectiveUserPermissionsSchemaError]:
      userPermissionsReducers.onGetEffectiveUserPermissionsSchemaError,
    [UpdateEffectiveUserPermissions]: userPermissionsReducers.onUpdateEffectiveUserPermissions,
    [UpdateEffectiveUserPermissionsSuccess]:
      userPermissionsReducers.onUpdateEffectiveUserPermissionsSuccess,
    [UpdateEffectiveUserPermissionsError]:
      userPermissionsReducers.onUpdateEffectiveUserPermissionsError,
    [ToggleEmployeeUsersModal]: userPermissionsReducers.onToggleEmployeeUsersModal,
  };
  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
